import styled from '@emotion/styled'
import { css, Theme, SerializedStyles } from '@emotion/react'

const Container = styled.main`
  --size: ${({ theme }) => theme.size.height[500]};

  & {
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '--size': [
          theme.size.height[400],
          theme.size.height[400],
          theme.size.height[400],
          theme.size.height[500],
        ],
      }),
    ).styles}
`

export function InnerModalStyle(theme: Theme): SerializedStyles[] {
  const styles = css`
    & {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: column nowrap;
      width: 90vw;
      max-width: 622px;
      padding: 0 0 59px 0;
    }

    .image-container {
      position: relative;
      padding: 0 0 0 0;
      width: 100%;
      height: 40vw;
      max-height: 165px;
    }

    .image-container > * {
      margin: -1px !important;
    }

    .label-container {
      font-size: var(--fs-100);
      font-weight: 300;
      line-height: normal;
      padding: 48px 0 32px 0;
      text-align: center;
      color: ${theme.colors.secondary[900]};
      max-width: ${theme.size.width[90]};
    }

    .label-container h1 {
      font-size: var(--fs-500);
      font-weight: 500;
    }

    .back-button {
      max-width: 260px;
      font-size: var(--fs-100);
    }

    ${css(
      theme.size.mq({
        '.back-button': {
          fontSize: ['var(--fs-50)', 'var(--fs-50)', 'var(--fs-100)'],
        },
      }),
    ).styles}
  `

  return [styles]
}

export default Container
